/**
 * @desc 财务画像-历史处罚-证监会
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import Ellips from '../../../common/ellipsisAndTooltip/EllipsisAndTooltip';
import AntdTable from '../../common/AntdTable';
// import {changeAnchor} from '../../common/commons';
import {commonColumns} from './columns';
import {getCSRCMeasures, getCSRCAdminist, getDistrustFirm,
    getAbnormal, getPIBXZCF, taxPunish, customPunish,
    administrative} from '../../../../services/financialPicture/historyPunish';
import { fieldAnomaly } from '../../../../utils/formatter';

export default class CSRCPunishment extends PureComponent {
    constructor(props) {
        super(props);
    }

    // 行政处罚和监管措施公用
    commonColumns = () => {
        return [
            {
                title: '序号',
                dataIndex: 'index',
                width: 80
            },
            {
                title: '公司简称',
                dataIndex: 'stock_short',
                width: 100
            },
            { 
                title: '文书名称', 
                dataIndex: 'case_name',
                render: text => <Ellips text={text} />
            },
            { 
                title: '文书标题', 
                dataIndex: 'title',
                render: text => <Ellips text={text} />
            },
            { 
                title: '正文', 
                dataIndex: 'main',
                render: text => <Ellips text={text} />
            },
            { 
                title: '处罚当事人', 
                dataIndex: 'person',
                render: fieldAnomaly
            },
            { 
                title: '发文日期', 
                dataIndex: 'pubdate'
            }
        ];
    };

    // 监管措施
    measuresColumns = () => {
        return [
            ...this.commonColumns(),
            { 
                title: '文书号', 
                dataIndex: 'case_code',
                render: text => <Ellips text={text} />
            }
        ];
    };

    // 行政处罚
    administColumns = () => {
        return [
            ...this.commonColumns(),
            { 
                title: '文书号', 
                dataIndex: 'punish_code'
            },
            { 
                title: '类别', 
                dataIndex: 'case_classify'
            },
            { 
                title: '处罚机构', 
                dataIndex: 'punish_org'
            }
        ];
    };

    // 海关总署失信企业信息
    chainCustoms = () => {
        return [
            { 
                title: '公司全称', 
                dataIndex: 'company_name',
                render: text => <Ellips text={text} />
            },
            { 
                title: '公司简称', 
                dataIndex: 'stock_short'
            },
            { 
                title: '公司代码', 
                dataIndex: 'stock_code'
            },
            { 
                title: '公布机构', 
                dataIndex: 'bbd_source',
                render: text => <Ellips text={text} />
            },
            { 
                title: '失信', 
                dataIndex: 'credit_status'
            }
        ];
    };

     // 经营异常
    abnormal = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            render: text => <Ellips text={text} />
        }, {
            title: '异常内容',
            dataIndex: 'busexcep_list',
            render: text => <Ellips text={text} />
        }, {
            title: '处罚对象',
            dataIndex: 'company_name'
        }, {
            title: '时间',
            dataIndex: 'rank_date'
        }];
    };

    // 保监局行政处罚
    IRBColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            render: text => <Ellips text={text} />
        }, {
            title: '案件标题',
            dataIndex: 'title'
        }, {
            title: '当事人',
            dataIndex: 'litigant'
        }, {
            title: '行政区',
            dataIndex: 'region'
        }, {
            title: '文书内容',
            dataIndex: 'main',
            render: text => <Ellips text={text} />
        }, {
            title: '时间',
            dataIndex: 'pubdate',
            render: text => <Ellips text={text} />
        }];
    };

    // 税务处罚
    taxColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            render: text => <Ellips text={text} />
        }, {
            title: '涉及公司',
            dataIndex: 'stock_short'
        }, {
            title: '统一社会信用代码',
            dataIndex: 'stock_code'
        }, {
            title: '披露机构',
            dataIndex: 'bbd_source',
            render: text => <Ellips text={text} />
        }, {
            title: '企业组织机构代码',
            dataIndex: 'bbd_source1',
            render: text => <Ellips text={text} />
        }, {
            title: '处罚内容',
            dataIndex: 'bbd_source11',
            render: text => <Ellips text={text} />
        }, {
            title: '时间',
            dataIndex: 'bbd_source111',
            render: text => <Ellips text={text} />
        }];
    };

    // 海关处罚
    customsColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            render: text => <Ellips text={text} />
        }, {
            title: '涉及公司',
            dataIndex: 'stock_short'
        }, {
            title: '披露机构',
            dataIndex: 'bbd_source8',
            render: text => <Ellips text={text} />
        }, {
            title: '企业名称',
            dataIndex: 'bbd_source',
            render: text => <Ellips text={text} />
        }, {
            title: '时间',
            dataIndex: 'bbd_source1',
            render: text => <Ellips text={text} />
        }];
    };

    render() {
        let content = [{
            title: '处罚内容',
            dataIndex: 'punish_content',
            render: fieldAnomaly
        }];
        return (
            <div>
                <AntdTable
                    idName={'punishment'} 
                    title={'证监会-行政处罚'} 
                    requestApi={getCSRCAdminist} 
                    columns={this.administColumns()} 
                />
                <AntdTable 
                    idName={'punishment-adminis-measures'}
                    title={'证监会-行政监管措施'} 
                    requestApi={getCSRCMeasures} 
                    columns={this.measuresColumns()} 
                />
                <AntdTable
                    idName={'abnormal-operation'}
                    title={'经营异常'}
                    requestApi={getAbnormal}
                    columns={this.abnormal()}
                />
                <AntdTable
                    idName={'IRB-adminis'}
                    title={'保监局行政处罚'}
                    requestApi={getPIBXZCF}
                    columns={this.IRBColumns()}
                />
                <AntdTable
                    idName={'adminis'}
                    title={'行政处罚'}
                    requestApi={administrative}
                    columns={commonColumns(content)}
                />
                {/* <AntdTable
                    idName={'adminis-regulatory'}
                    title={'行政监管措施'}
                    requestApi={getDistrustFirm}
                    columns={commonColumns(content)}
                /> */}
                {/* <AntdTable
                    idName={'inquiry-history'}
                    title={'问询历史'}
                    requestApi={getDistrustFirm}
                    columns={commonColumns(title)}
                />
                <AntdTable
                    idName={'regulatory-letters'}
                    title={'监管函件'}
                    requestApi={getDistrustFirm}
                    columns={commonColumns(title)}
                /> */}
                <AntdTable
                    idName={'tax-punish'}
                    title={'税务处罚'}
                    requestApi={taxPunish}
                    columns={this.taxColumns()}
                />
                <AntdTable
                    idName={'customs-sanction'}
                    title={'海关处罚'}
                    requestApi={customPunish}
                    columns={this.customsColumns()}
                />
                <AntdTable
                    idName={'chain-customs'} 
                    title={'海关总署失信企业信息'} 
                    requestApi={getDistrustFirm} 
                    columns={this.chainCustoms()} 
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/historyPunishment/subComponents/CSRCPunishment.jsx